
















import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseSpinner from "@/components/BaseSpinner";
import { FollowerMappedType } from "../type";

export default defineComponent({
  name: "SearchUserItem",
  components: { BaseSpinner, BaseAvatar },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
    mappedFollowings: { type: Object as () => FollowerMappedType, default: {} },
    loading: { type: Boolean },
    followingInProcessUsers: { type: Array as () => string[], default: [] },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const profileUrl = computed<Location>(() => getProfileUrl(props.user));
    const isFollowed = computed<boolean>(() => !!props.mappedFollowings[props.user.id]);
    const followingInProgress = computed<boolean>(() => props.followingInProcessUsers.some(id => id === props.user.id));
    return {
      authUser,
      profileUrl,
      isFollowed,
      followingInProgress,
    };
  },
});
